import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

$(function () {
  $('.js-dropdown-click').on('click', function () {
    $(this).toggleClass('is_open');
    $(this).closest('.homeSec04-leaderList__item').find('.homeSec04-leaderList__dropdown').slideToggle();
    var target = $(this).closest('.homeSec04-leaderList__item');
    window.scrollTo(0, target.offset().top);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const mvSlider = new Swiper(".homeSecMv-slide", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".homeSecMv .swiper-button-next",
      prevEl: ".homeSecMv .swiper-button-prev",
    },
    pagination: {
      el: ".homeSecMv .swiper-pagination",
      clickable: true,
    },
    on: {
      init(swiper) {
        document.dispatchEvent(
          new CustomEvent("wwbHomeMvSlideChange", { detail: { realIndex: swiper.realIndex } })
        );
      },
      slideChange(swiper) {
        document.dispatchEvent(
          new CustomEvent("wwbHomeMvSlideChange", { detail: { realIndex: swiper.realIndex } })
        );
      },
    },
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".homeSec01-tab");
  const contents = document.querySelectorAll(".homeSec01-tabContent");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.tab;

      tabs.forEach(t => t.classList.remove("is-active"));
      contents.forEach(c => c.classList.remove("is-active"));

      tab.classList.add("is-active");
      document.getElementById(target).classList.add("is-active");
    });
  });

  // homeSec02: 矢印を各 .homeSec02-txtBox__ttl の右端まで移動する量を算出し CSS 変数で渡す
  function setArrowTranslateX() {
    document.querySelectorAll(".homeSec02-txtBox__ttl").forEach((ttl) => {
      const span = ttl.querySelector(":scope > span");
      if (!span) return;
      const ttlRect = ttl.getBoundingClientRect();
      const spanRect = span.getBoundingClientRect();
      if (ttlRect.width < 1 || spanRect.width < 1) return;
      const paddingRight = parseFloat(getComputedStyle(ttl).paddingRight) || 0;
      const ttlContentRight = ttlRect.right - paddingRight;
      const arrowRightEdge = spanRect.right;
      const translateX = ttlContentRight - arrowRightEdge;
      ttl.style.setProperty("--arrow-translate-x", `${translateX}px`);
    });
  }

  function scheduleArrowTranslateX() {
    requestAnimationFrame(() => {
      requestAnimationFrame(setArrowTranslateX);
    });
  }

  // .is-anim が付いた要素が画面内に入ってからある程度見えたら .is-revealed を付与／外れたら削除（アニメーションは SCSS で定義）
  const animTargets = document.querySelectorAll(".is-anim");
  if (animTargets.length && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            scheduleArrowTranslateX();
          } else {
            entry.target.classList.remove("is-revealed");
          }
        });
      },
      { rootMargin: "0px 0px -15% 0px", threshold: 0 }
    );
    animTargets.forEach((el) => observer.observe(el));
  }

  scheduleArrowTranslateX();
  window.addEventListener("resize", scheduleArrowTranslateX);

  window.addEventListener("load", scheduleArrowTranslateX);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => scheduleArrowTranslateX());
  }

  // .homeSec02 の行が is-fadeUp 後に transform でスライドするため、完了後に再計算しないと矢印位置がずれる
  document.querySelectorAll(".homeSec02-serviceItem").forEach((item) => {
    item.addEventListener("transitionend", (e) => {
      if (e.target === item && e.propertyName === "transform") {
        scheduleArrowTranslateX();
      }
    });
  });
});